import NormalizeWheel from 'normalize-wheel'
import gsap from 'gsap'
//
import Animation from 'Scripts/classes/Animation'
import Media from './Media'
import { clamp, lerp, deviceType, isTouchDevice } from 'Scripts/utils/utils'

export default class Carousel extends Animation {
  constructor({ wrapper, carouselSelector, mediasSelector, loop, autoplay }) {
    super({
      element: carouselSelector,
      elements: {
        wrapper,
        carousel: carouselSelector,
        carouselMedias: mediasSelector,
        defaultCursor: '.cursor__wrapper .cursor',
        dragCursor: '.cursor__wrapper .drag',
      },
    })

    this.loop = loop || false
    this.autoplay = autoplay || false
    this.gap = getComputedStyle(this.elements.carousel).columnGap

    //
    this.speed = 1
    this.screen = {
      width: window.innerWidth,
      height: window.innerHeight,
    }
    this.scroll = {
      ease: 0.05,
      position: 0,
      current: 0,
      target: 0,
      last: 0,
    }

    this.device = deviceType()
    this.isMobile = this.device === 'mobile'
    if (this.isMobile) this.scroll.ease = 0.1
    this.isTouchDevice = isTouchDevice()
    //
    this.onResize()
    this.elements.carouselMedias && this.createCarousel()
  }

  createCarousel() {
    // console.log(this.elements.carouselMedias)
    this.medias = [...this.elements.carouselMedias].map(
      (media, index) =>
        new Media({ media, index, carouselSize: this.carouselSize, loop: this.loop, gap: this.gap })
    )
  }

  getBounds() {
    // this.Bounds = this.elements.carousel.getBoundingClientRect()
    // this.carouselSize = {
    //   width: this.Bounds.width,
    //   height: this.Bounds.height
    // }
    this.carouselSize = {
      width: this.elements.carousel.scrollWidth,
      height: this.elements.carousel.scrollHeight,
    }
  }

  animateIn() {
    super.animateIn()

    gsap.to(this.element, {
      autoAlpha: 1,
      x: `${this.offset}px`,
      duration: 1.5,
      delay: 0.3,
      // ease: 'Power3.easeOut',
      onComplete: () => {
        // this.loop && gsap.set(this.elements.carouselItems, { animationPlayState: 'running' })
        this.addEventListener()
        this.update()
        super.deleteObserver()
      },
    })
  }

  animateOut() {
    super.animateOut()
    gsap.set(this.element, {
      autoAlpha: 0,
      x: '100%',
      onComplete: () => {
        // this.loop && gsap.set(this.elements.carouselItems, { animationPlayState: 'paused' })
      },
    })
  }

  addEventListener() {
    // this.elements.carousel.addEventListener('mousewheel', this.onWheel.bind(this))
    // this.elements.carousel.addEventListener('wheel', this.onWheel.bind(this))

    // add passive flag to fix chrome warning
    //Touch
    this.elements.wrapper.addEventListener('touchstart', this.onTouchDown.bind(this), {
      passive: true,
    })
    window.addEventListener('touchend', this.onTouchUp.bind(this), { passive: true })
    this.elements.wrapper.addEventListener('touchmove', this.onTouchMove.bind(this), {
      passive: true,
    })
    //Mouse
    this.elements.wrapper.addEventListener('mousedown', this.onTouchDown.bind(this))
    window.addEventListener('mouseup', this.onTouchUp.bind(this))
    this.elements.wrapper.addEventListener('mousemove', this.onTouchMove.bind(this))
    !this.isTouchDevice &&
      this.elements.wrapper.addEventListener('mouseenter', this.onMouseEnter.bind(this))
    !this.isTouchDevice &&
      this.elements.wrapper.addEventListener('mouseleave', this.onMouseLeave.bind(this))

    window.addEventListener('resize', this.onResize.bind(this))
  }

  onTouchDown(e) {
    e.preventDefault()
    // console.log('onTouchDown', this.isDown)
    //
    this.isDown = true
    this.scroll.position = this.scroll.current
    this.start = e.touches ? e.touches[0].clientX : e.clientX

    !this.isMobile &&
      gsap.to(this.elements.wrapper, {
        scale: 0.96,
        duration: 0.3,
      })
  }

  onTouchUp(e) {
    e.preventDefault()
    // console.log('onTouchUp')
    this.isDown = false
    !this.isMobile &&
      gsap.to(this.elements.wrapper, {
        scale: 1,
        duration: 0.3,
      })
  }

  onTouchMove(e) {
    e.preventDefault()
    if (!this.isMobile && !this.isDown) return
    // console.log('onTouchMove')
    //
    const x = e.touches ? e.touches[0].clientX : e.clientX
    const distance = (x - this.start) * 3
    //
    this.scroll.target = this.scroll.position + distance

    if (!this.loop) {
      //Option without infinit drag
      this.scroll.target =
        this.scroll.target <= -this.limit ? -this.limit - this.offset : this.scroll.target
      this.scroll.target = this.scroll.target >= 0 ? 0 : this.scroll.target
    }
    // console.log(this.scroll.target, this.limit, this.offset)
  }

  onWheel(e) {
    // console.log('onWheel')
    const { pixelY } = NormalizeWheel(e)
    this.scroll.target += pixelY
  }

  onMouseEnter() {
    // console.log('onMouseEnter')
    gsap.to(this.elements.defaultCursor, {
      autoAlpha: 0,
      duration: 0.3,
      onComplete: () => {
        gsap.to(this.elements.dragCursor, {
          display: 'block',
          autoAlpha: 1,
          duration: 0.3,
        })
      },
    })
  }

  onMouseLeave() {
    // console.log('onMouseLeave')

    gsap.to(this.elements.defaultCursor, {
      display: 'block',
      autoAlpha: 1,
      duration: 0.3,
      onComplete: () => {
        gsap.to(this.elements.dragCursor, {
          display: 'none',
          autoAlpha: 0,
          duration: 0.3,
        })
      },
    })
  }

  updateX() {
    this.elements.carousel.style.left = this.scroll.current + this.extraX + 'px'
  }

  update() {
    if (this.autoplay) {
      this.scroll.target += this.speed
    }
    //use lerp if is not in touch mode and transition on non touch device
    // if (this.device !== 'mobile') {
    //   this.scroll.current = lerp(this.scroll.current, this.scroll.target, this.scroll.ease)
    // } else {
    //   this.scroll.current = this.scroll.target
    // }

    // this.scroll.target = clamp(0, this.scroll.limit, this.scroll.target)
    this.scroll.current = lerp(this.scroll.current, this.scroll.target, this.scroll.ease)
    if (this.scroll.current < 0.01 && this.scroll.current > -0.01) {
      this.scroll.current = 0
    }

    //Direction
    if (this.scroll.current > this.scroll.last) {
      this.direction = 'right'
      this.speed *= 1
    } else if (this.scroll.current < this.scroll.last) {
      this.direction = 'left'
      this.speed *= -1
    }
    //
    this.updateX()
    // this.medias && this.medias.forEach(media => media.update(this.scroll, this.direction))
    //
    this.scroll.last = this.scroll.current
    //
    requestAnimationFrame(this.update.bind(this))
  }

  onResize() {
    this.extraX = 0
    this.elements.carousel && this.getBounds()

    if (this.device === 'mobile') {
      this.offset = 25
    } else {
      this.offset = (window.innerWidth - 1240) / 2
    }
    this.limit = this.elements.carousel.scrollWidth - this.screen.width + this.offset

    this.screen = {
      width: window.innerWidth,
      height: window.innerHeight,
    }

    this.medias && this.medias.forEach((media) => media.onResize(this.carouselSize))
  }
}
